<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete v-model="customer_id.value.value" label="Customer" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="getCustomerList" item-title="company_name"
                        item-value="id" clearable hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-autocomplete v-model="product_id.value.value" label="Product" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="getProductList" :item-title="item => `${item.code}-${item.name}` ?? 'N/A'" item-value="id"
                        clearable hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete v-model="warehouse_id.value.value" label="Warehouse" bg-color="grey-lighten-4"
                        variant="outlined" density="compact" :items="getWarehouseList" item-title="name" item-value="id"
                        clearable hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      <v-select v-model="status.value.value" label="Status" bg-color="grey-lighten-4" variant="outlined"
                        density="compact" :items="statusOptions" item-title="title" item-value="value" clearable
                        hide-details class="py-1" 
                          :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" v-model="from_date.value.value" label="From Date"
                        bg-color="grey-lighten-4" prepend-icon="" prepend-inner-icon="mdi-calendar-month"
                        variant="outlined" density="compact" clearable hide-details class="py-1" />
                      <v-btn class="bg-brand my-1" type="submit" :loading="loading">Search</v-btn>
                    </v-col>
                    <v-col lg="3" md="3" cols="12">
                      <v-date-input input-format="dd/mm/yyyy" v-model="to_date.value.value" label="To Date"
                        bg-color="grey-lighten-4" prepend-icon="" prepend-inner-icon="mdi-calendar-month"
                        variant="outlined" density="compact" clearable hide-details class="py-1" />
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Gatepass Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search" hide-details
                      density="compact" variant="outlined" clearable />
                  </v-col>
                  <v-col md="4" cols="12" class="d-flex justify-center">
                    <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                      <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                        @click="exportToCSV">CSV</v-btn>
                      <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                        @click="exportToExcel">EXCEL</v-btn>
                      <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                    </v-btn-group>
                  </v-col>
                </v-row>
                <v-data-table :headers="reportHeaders" :items="reports?.data || []" :loading="loading"
                  v-model:items-per-page="itemsPerPage" :search="search" hover density="compact">
                  <template #item.quantity="{ item }">
                    {{ formatNumber(item.quantity) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter.js";
export default {
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    search: "",
    statusOptions: [
      { title: "Pending", value: "Pending" },
      { title: "Approved", value: "Approved" },
      { title: "Cancelled", value: "Cancelled" },
    ],
    headers: [
      { title: "SL", key: "sl", align: "center", sortable: false },
      { title: "Gate Pass No.", key: "gate_pass_no", align: "left", sortable: false },
      { title: "Reference No.", key: "reference_no", align: "left", sortable: false },
      { title: "Person/Company Name", key: "person_company_name", align: "left", sortable: false },
      { title: "Contact No.", key: "contact_no", align: "left", sortable: false },
      { title: "Item Code", key: "item_code", align: "left", sortable: false },
      { title: "Item Name", key: "item_name", align: "left", sortable: false },
      { title: "Description", key: "description", align: "left", sortable: false },
      { title: "UOM", key: "uom", align: "left", sortable: false },
      { title: "Quantity", key: "quantity", align: "end", sortable: false },
      { title: "Purpose", key: "purpose", align: "left", sortable: false },
      { title: "From Location", key: "from_location", align: "left", sortable: false },
      { title: "Destination", key: "destination", align: "left", sortable: false },
      { title: "Vehicle No.", key: "vehicle_no", align: "left", sortable: false },
      { title: "Driver/Courier", key: "driver_courier", align: "left", sortable: false },
      { title: "Expected Return Date", key: "expected_return_date", align: "left", sortable: false },
      { title: "Actual Return Date", key: "actual_return_date", align: "left", sortable: false },
      { title: "Prepared By", key: "prepared_by", align: "left", sortable: false },
      { title: "Approved By", key: "approved_by", align: "left", sortable: false },
      { title: "Security Checked By", key: "security_checked_by", align: "left", sortable: false },
      { title: "In/Out Time", key: "in_out_time", align: "left", sortable: false },
      { title: "Status", key: "status", align: "left", sortable: false },
      { title: "Remarks", key: "remarks", align: "left", sortable: false },
    ],
  }),
  computed: {
    reportHeaders() {
      const columns = this.reports?.columns;
      if (!Array.isArray(columns) || !columns.length) return this.headers;
      return columns.map(({ field, label }) => ({ title: label, key: field, align: field === "sl" ? "center" : "start", sortable: false }));
    },
    getCustomerList() {
      return (this.$store.getters.getCustomerList || []).filter((item) => item.status == 1);
    },
    getProductList() {
      return (this.$store.getters.getProductList || []).filter((item) => item.status == 1);
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList || [];
    },
  },
  created() {
    if (this.getCustomerList.length === 0) this.$store.dispatch("getCustomerList");
    if (this.getProductList.length === 0) this.$store.dispatch("getProductList");
    if (this.getWarehouseList.length === 0) this.$store.dispatch("getWarehouseList");
  },
  setup() {
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });
    const customer_id = useField("customer_id");
    const product_id = useField("product_id");
    const warehouse_id = useField("warehouse_id");
    const status = useField("status");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const store = useStore();
    const loading = ref(false);
    const reports = ref({});

    const submit = handleSubmit((values) => {
      loading.value = true;
      const params = {
        ...values,
        from_date: formattedDate(values.from_date),
        to_date: formattedDate(values.to_date),
      };

      store
        .dispatch("getInvGatepassReport", params)
        .then((response) => {
          reports.value = response.data;
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Unable to load report");
        })
        .finally(() => {
          loading.value = false;
        });
    });

    return {
      customer_id,
      product_id,
      warehouse_id,
      status,
      from_date,
      to_date,
      loading,
      reports,
      submit,
    };
  },
  methods: {
    formatNumber(value) {
      return value == null ? "" : Number(value).toFixed(2);
    },
    exportRows() {
      return [
        this.reportHeaders.map((header) => header.title),
        ...(this.reports?.data || []).map((item) =>
          this.reportHeaders.map((header) => item[header.key] ?? "")
        ),
      ];
    },
    exportToCSV() {
      this.$exportTableToCSV(
        this.exportRows(),
        `gatepass_report_${this.$fileDate()}`
      );
    },
    exportToExcel() {
      this.$exportTableToExcel(
        this.exportRows(),
        `gatepass_report_${this.$fileDate()}`
      );
    },
    exportToPDF() {
      this.$exportTableToPDF(
        this.reportHeaders.map((header) => header.title),
        (this.reports?.data || []).map((item) =>
          this.reportHeaders.map((header) => item[header.key] ?? "")
        ),
        "Gatepass Report",
        `gatepass_report_${this.$fileDate()}`
      );
    },
  },
  mounted() {
    const date = new Date();
    const futureDate = new Date();
    futureDate.setDate(date.getDate() + 30);
    this.from_date.value.value = date;
    this.to_date.value.value = futureDate;
  },
};
</script>
